
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Swiftdzireonrentinmumbai() {



    const cardData =
    {
        keyword: ' Swift Dzire on Rent in Mumbai',
        heading: 'Deva Cabs:  Swift Dzire on Rent in Mumbai',
        headingDescription: 'Deva Cabs offers reliable, economical, and hassle-free Swift Dzire rentals in Mumbai. Perfect for daily commutes, local sightseeing, airport transfers, and outstation travel, the Swift Dzire combines comfort, mileage, and compact elegance. Whether you are traveling solo, with family, or for business, our well-maintained Dzire cars and professional drivers ensure a smooth and pleasant ride. With budget-friendly rates, flexible rental durations, and on-time service, Deva Cabs guarantees a convenient and comfortable travel experience with Swift Dzire in Mumbai.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Located by the Arabian Sea in Colaba, this Indo-Saracenic structure stands 26 meters tall and draws millions of tourists each year. It serves as a starting point for ferry rides to Elephanta Caves and offers scenic views, especially during sunrise and sunset. Surrounded by bustling vendors, photographers, and the majestic Taj Mahal Palace Hotel, it’s a must-visit symbol of the city’s colonial past and vibrant present."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive, also known as the 'Queen’s Necklace', is a 3.6 km long C-shaped boulevard along the Arabian Sea in South Mumbai. Lined with palm trees and iconic Art Deco buildings (a UNESCO heritage stretch), it offers an idyllic promenade for evening walks and ocean breezes. At night, the streetlights create a necklace-like illusion across the bay. Locals and tourists come here to relax, jog, enjoy local snacks at Chowpatty Beach, or simply take in the magnificent sunset skyline."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "location": "Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage Site, CST (formerly Victoria Terminus) is a historic railway station in South Mumbai, built in 1887 in the Victorian Gothic Revival style. The station's stunning architecture, domes, turrets, pointed arches, and stained glass make it one of the most photographed buildings in India. Still functioning as a busy train terminal, CST represents the fusion of British and Indian architectural traditions and serves as a central landmark in Mumbai's bustling Fort area."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai, Maharashtra",
    "description": "Situated on Elephanta Island, about 11 km from the Gateway of India, the Elephanta Caves are a UNESCO World Heritage Site featuring ancient rock-cut cave temples dedicated to Lord Shiva. The main cave houses the iconic 20-foot Trimurti sculpture, representing Shiva in three forms. Dating back to the 5th to 7th centuries, these caves offer a unique glimpse into India's early rock architecture. Visitors reach the island via ferry and can enjoy scenic views, local souvenirs, and a toy train ride upon arrival."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is one of the most famous and accessible beaches in Mumbai, stretching along the Arabian Sea in the upscale Juhu suburb. It's a popular spot for watching sunsets, street food (try bhelpuri and pav bhaji), and celebrity sightings. On weekends and during festivals like Ganesh Chaturthi, the beach becomes a vibrant social hub with locals, tourists, kids, and vendors creating a lively atmosphere. Its proximity to film studios and luxury hotels also makes it a favorite among Bollywood stars."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "Sanjay Gandhi National Park is a 100-square-kilometer green oasis within Mumbai, offering a mix of nature, history, and adventure. Home to leopards, deer, and over 250 species of birds, the park also houses the 2,000-year-old Kanheri Caves, which are Buddhist rock-cut monuments carved into basalt rock. Visitors can enjoy jungle safaris, cycling trails, boating, toy train rides, and trekking paths—making it an ideal retreat for families and nature lovers right within city limits."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Mumbai, Maharashtra",
    "description": "Haji Ali Dargah is a revered Islamic shrine located on an islet off the coast of Worli in South Mumbai. Built in 1431, it houses the tomb of the saint Pir Haji Ali Shah Bukhari. The white marble structure is accessible via a narrow walkway surrounded by water, especially mesmerizing during high tide. It's a spiritual destination visited by people of all faiths, offering stunning views of the sea and the city’s skyline."
  },
  {
    "title": "Chor Bazaar",
    "location": "Mumbai, Maharashtra",
    "description": "Chor Bazaar, meaning 'Thieves' Market', is one of the oldest and most fascinating flea markets in Mumbai. Located near Grant Road, it’s a treasure trove for antique collectors and bargain hunters. You'll find vintage Bollywood posters, colonial furniture, old gramophones, brassware, and more. Though it was once associated with stolen goods, today it’s more about quirky curios and Mumbai’s vintage charm."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "location": "Mumbai, Maharashtra",
    "description": "Officially named Rajiv Gandhi Sea Link, this 5.6 km long cable-stayed bridge connects the suburbs of Bandra to Worli, reducing travel time dramatically. The bridge stands as a symbol of modern Mumbai, offering scenic views of the city’s skyline and the Arabian Sea. It’s especially stunning at night when illuminated. While stopping is prohibited on the bridge, the view from Bandra Fort or Worli Sea Face is a favorite for photographers and couples."
  },
  {
    "title": "Global Vipassana Pagoda",
    "location": "Gorai, Mumbai, Maharashtra",
    "description": "The Global Vipassana Pagoda is a massive meditation hall built as a tribute to the teachings of Lord Buddha. Its dome, one of the world’s largest stone structures without supporting pillars, can seat over 8,000 people. Located near Gorai Creek, the pagoda complex includes a museum, library, and guided Anapana meditation sessions. Its golden structure and peaceful surroundings attract spiritual seekers and curious tourists alike."
  }
],



  "services": [
    {
      "name": "Swift Dzire on Rent in Mumbai",
      "description": "Looking to rent a Swift Dzire in Mumbai? Deva Cabs offers comfortable and affordable Swift Dzire rentals ideal for city commutes, business use, or intercity travel. Known for its fuel efficiency and smooth ride, the Swift Dzire is perfect for those who want a reliable sedan with ample space and air conditioning. All our vehicles come with professional chauffeurs and are regularly maintained for cleanliness and safety. Whether it's a single-day use or a multi-day plan, our Swift Dzire rental is a dependable choice for hassle-free travel in and around Mumbai."
    },
    {
      "name": "Book Swift Dzire Cab Mumbai",
      "description": "Booking a Swift Dzire cab in Mumbai is quick and simple with Deva Cabs. Our online platform and customer support make it easy to reserve your ride in just a few steps. Whether you’re heading to work, visiting family, or going on a city tour, the Swift Dzire offers a balance of comfort, economy, and space. All bookings come with timely service, transparent fares, and a professional driver to make your travel seamless and stress-free."
    },
    {
      "name": "Chauffeur Swift Dzire Hire Mumbai",
      "description": "Enjoy the comfort of a chauffeur-driven Swift Dzire hire in Mumbai with Deva Cabs. Our experienced and courteous drivers ensure a safe and relaxing ride, whether you're attending meetings, weddings, or airport transfers. The Swift Dzire offers ample boot space for luggage, plush interiors for comfort, and AC for all-weather travel. Hire our chauffeur service for a premium travel experience with punctuality and professionalism guaranteed."
    },
    {
      "name": "Affordable Swift Dzire Rental Mumbai",
      "description": "Travel smart with Deva Cabs’ affordable Swift Dzire rentals in Mumbai. Ideal for individuals and small families, the Dzire offers excellent mileage and ride quality at budget-friendly prices. We offer flexible pricing plans — hourly, daily, or outstation packages. With no hidden charges and transparent billing, you get maximum value with every ride. Perfect for personal use, work commutes, or weekend getaways."
    },
    {
      "name": "Swift Dzire for Airport Cab Mumbai",
      "description": "Need a reliable airport cab in Mumbai? Our Swift Dzire service offers smooth airport transfers with on-time pickups and drop-offs to and from both domestic and international terminals. Our chauffeurs track your flight for delays and ensure prompt service. The Swift Dzire’s spacious seating and AC comfort make it ideal for relaxing after a flight or reaching the airport without stress."
    },
    {
      "name": "Swift Dzire for Outstation Mumbai",
      "description": "Plan your next outstation trip from Mumbai with our Swift Dzire rental service. Whether you're heading to Pune, Nashik, Lonavala, or Goa, the Swift Dzire offers a comfortable and economical option for long-distance travel. With professional drivers, well-maintained cars, and transparent pricing, you can enjoy the journey as much as the destination. Suitable for solo travelers, couples, and small families."
    },
    {
      "name": "Dzire Car Rental for Corporate Travel Mumbai",
      "description": "Deva Cabs offers professional Dzire car rental services for corporate travel in Mumbai. Whether it's client meetings, airport transfers for executives, or daily office commutes, our Swift Dzire fleet ensures a dependable and professional ride. With corporate billing options, on-time service, and uniformed chauffeurs, we help companies streamline travel logistics while keeping comfort and cost-efficiency in mind."
    },
    {
      "name": "Swift Dzire Family Cab Mumbai",
      "description": "Travel with your loved ones in a spacious and comfortable Swift Dzire family cab in Mumbai. Our service is perfect for family outings, shopping days, temple visits, or weekend escapes. With child-safe seating, AC comfort, and experienced drivers, your entire family can enjoy the ride in a secure and relaxed environment. Book your family cab easily through our app or website."
    },
    {
      "name": "AC Dzire Cab Mumbai",
      "description": "Beat the heat and enjoy every ride with our AC Swift Dzire cabs in Mumbai. Whether you’re traveling for business or leisure, our fully air-conditioned Dzire vehicles provide a cool and pleasant environment even during Mumbai’s humid weather. Our fleet is cleaned regularly, and each ride comes with a courteous, background-verified chauffeur for your safety and comfort."
    },
    {
      "name": "Online Swift Dzire Booking Mumbai",
      "description": "Book a Swift Dzire in Mumbai in just a few clicks with our easy-to-use online booking system. Select your pickup location, travel date, and cab type, and we’ll handle the rest. Instant confirmations, secure payment options, and real-time driver tracking make the experience convenient and reliable. Whether it’s for today or a future date, online booking ensures your ride is ready when you are."
    },
    {
      "name": "Dzire for Daily Hire Mumbai",
      "description": "Need a car for the full day? Our daily hire Swift Dzire service in Mumbai offers flexible packages for local travel, business visits, errands, or multiple stops throughout the city. Enjoy the convenience of a full-day cab at economical rates with no waiting charges or surge pricing. Your personal driver will stay with you throughout the day to ensure comfortable, door-to-door service."
    },
    {
      "name": "Swift Dzire City Tour Mumbai",
      "description": "Explore the vibrant city of Mumbai in comfort with our Swift Dzire city tour service. Ideal for tourists and locals alike, our service covers major attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Bandra-Worli Sea Link, and more. Our trained drivers double as local guides, ensuring you experience the best of Mumbai with flexible stops, clean cars, and an enjoyable ride."
    }
  ],
  "tableData": [
    ["Swift Dzire on Rent in Mumbai", "-Book Swift Dzire Cab Mumbai"],
    ["Chauffeur Swift Dzire Hire Mumbai", "-Affordable Swift Dzire Rental Mumbai"],
    ["Swift Dzire for Airport Cab Mumbai", "-Swift Dzire for Outstation Mumbai"],
    ["Dzire Car Rental for Corporate Travel Mumbai", "-Swift Dzire Family Cab Mumbai"],
    ["AC Dzire Cab Mumbai", "-Online Swift Dzire Booking Mumbai"],
    ["Dzire for Daily Hire Mumbai", "-Swift Dzire City Tour Mumbai"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Well-Maintained Swift Dzire Fleet in Mumbai",
    "WhyChoosedescription": "Deva Cabs offers a fleet of clean, fuel-efficient, and regularly serviced Swift Dzire vehicles that are ideal for both city travel and outstation trips. Each car undergoes routine maintenance, cleanliness checks, and mechanical inspections, ensuring a reliable and hassle-free experience for every renter."
  },
  {
    "WhyChooseheading": "Perfect Balance of Comfort and Affordability",
    "WhyChoosedescription": "Swift Dzire is known for its excellent mileage, smooth suspension, and spacious interiors—all at a budget-friendly price. Whether you're traveling alone, with family, or need a work commute solution, the Dzire offers comfort without compromising on cost."
  },
  {
    "WhyChooseheading": "Ideal for City Rides and Long-Distance Journeys",
    "WhyChoosedescription": "The Swift Dzire performs exceptionally well on Mumbai’s city roads and highways alike. Its compact size makes it easy to navigate traffic and park in tight spots, while its powerful engine and stable ride quality ensure smooth travel for outstation trips to places like Pune, Nashik, or Lonavala."
  },
  {
    "WhyChooseheading": "Chauffeur-Driven Swift Dzire Rentals",
    "WhyChoosedescription": "Enjoy a stress-free ride with our trained, courteous, and professional chauffeurs. Whether you’re attending meetings, airport pickups, weddings, or weekend trips, our drivers ensure punctuality, safe driving, and a pleasant in-cab experience throughout your rental period."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing Plans",
    "WhyChoosedescription": "With Deva Cabs, you get fixed, all-inclusive pricing for Swift Dzire rentals in Mumbai. No hidden charges, no surprise fuel costs—just transparent billing based on the duration and type of service you choose. Hourly, full-day, and outstation packages are available at competitive rates."
  },
  {
    "WhyChooseheading": "Available 24/7 for All Your Travel Needs",
    "WhyChoosedescription": "Whether you need a Swift Dzire early in the morning for a business trip or late at night after a function, our fleet is available around the clock. You can book anytime through our app, website, or customer support for instant confirmation and service availability."
  },
  {
    "WhyChooseheading": "Quick and Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a Swift Dzire with Deva Cabs takes just a few seconds. Use our intuitive mobile app or website to select your ride, confirm pricing, and track your driver in real-time. Prefer personal assistance? Our 24/7 call support is ready to help with bookings and modifications."
  },
  {
    "WhyChooseheading": "Custom Rental Packages for Every Occasion",
    "WhyChoosedescription": "From airport transfers and office commutes to wedding transport and weekend getaways, Deva Cabs offers tailored Swift Dzire rental packages to meet every requirement. Choose between one-way drops, round trips, or multi-day bookings—your comfort, your schedule, your way."
  }
]













    }




const faqData = [
  {
    question: "Can I rent a Swift Dzire in Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs offers Swift Dzire on rent in Mumbai. You can book the car easily through our website, mobile app, or by contacting our customer support team."
  },
  {
    question: "What is the rental fare for a Swift Dzire in Mumbai?",
    answer: "The rental fare for a Swift Dzire in Mumbai depends on the duration of the rental, the type of service, and whether it's a one-way or round-trip booking. You can check the exact fare through our website or mobile app, or get in touch with customer support."
  },
  {
    question: "Are there any discounts on renting a Swift Dzire in Mumbai?",
    answer: "We often offer special deals and discounts on car rentals, including Swift Dzire. Check our website or app for the latest offers."
  },
  {
    question: "Can I rent a Swift Dzire for both short and long durations in Mumbai?",
    answer: "Yes, you can rent a Swift Dzire for both short and long durations in Mumbai, whether it's for a few hours, a day, or even a week."
  },
  {
    question: "What are the payment options for renting a Swift Dzire in Mumbai?",
    answer: "We accept a variety of payment options, including cash, credit/debit cards, UPI, and online payments through our mobile app or website."
  },
  {
    question: "Can I pre-schedule my Swift Dzire rental in Mumbai?",
    answer: "Yes, you can pre-schedule your Swift Dzire rental for any date and time via our booking portal or mobile app. Choose your preferred pick-up time for a hassle-free experience."
  },
  {
    question: "Is the Swift Dzire available with a driver in Mumbai?",
    answer: "Yes, we offer the Swift Dzire rental with an experienced, verified driver. Our drivers are familiar with Mumbai's routes to ensure a smooth and safe journey."
  },
  {
    question: "Is the Swift Dzire in good condition?",
    answer: "Absolutely! All our rental cars, including the Swift Dzire, are regularly maintained, cleaned, and thoroughly inspected to ensure a comfortable and safe ride."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Sameer Gupta',
    role: 'Business Traveler',
    review: 'I rented a Swift Dzire from Deva Cabs for a business trip in Mumbai. The car was in excellent condition, and the driver was very professional. It was a comfortable and convenient experience.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Rina Desai',
    role: 'Tourist',
    review: 'I rented a Swift Dzire for a day trip around Mumbai with Deva Cabs. The car was clean and spacious, and the driver was very courteous. Highly recommend this service for anyone visiting Mumbai!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];
































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Mumbai",
  "image": "https://devacab.com/assets/images/swift-dzire-on-rent-in-mumbai.jpg", // Replace with actual image URL
  "description": "Swift Dzire on rent in Mumbai by Deva Cabs. Comfortable AC sedan for airport transfers, outstation trips, corporate travel, city tours, and daily hire. Affordable chauffeur-driven car rental with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299", // Example starting fare, update as needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/swift-dzire-on-rent-in-mumbai" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Swift Dzire on Rent in Mumbai | Chauffeur-Driven Dzire Cab | Deva Cabs</title>
  <meta
    name="description"
    content="Book Swift Dzire on rent in Mumbai with Deva Cabs. AC sedan ideal for airport cabs, outstation trips, city tours, and corporate or family travel. Affordable and chauffeur-driven service with online booking."
  />
  <meta
    name="keywords"
    content="Swift Dzire on Rent in Mumbai, Book Swift Dzire cab Mumbai, Chauffeur Swift Dzire hire Mumbai, Affordable Swift Dzire rental Mumbai, Swift Dzire for airport cab Mumbai, Swift Dzire for outstation Mumbai, Dzire car rental for corporate travel Mumbai, Swift Dzire family cab Mumbai, AC Dzire cab Mumbai, Online Swift Dzire booking Mumbai, Dzire for daily hire Mumbai, Swift Dzire city tour Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Swiftdzireonrentinmumbai;